import AzureBlobService from "./azureblobservice";
import { arrayBufferToBase64 } from "./helpers";

const tempuserGuid = "a000000000000000000000000000000a";

const checkIfFileExists = async (envelopeDocID) => {
  const fileName = `${envelopeDocID}.json`;
  return await AzureBlobService.fileExists(tempuserGuid, fileName);
};

const addSignerFilesIfMissing = async (envelopeDocID, modifiedName) => {
  try {
    const fileName = `temp_${modifiedName}`;
    const signedFileName = `signed_${envelopeDocID}.pdf`;
    // Get file bytes from Blob Storage
    const fileBytes = await AzureBlobService.getFileBytes(tempuserGuid, fileName);
    if (!fileBytes) throw new Error("Failed to fetch file bytes");

    // Upload signed file to Blob Storage
    await AzureBlobService.uploadFile(tempuserGuid, signedFileName, fileBytes);

    // Prepare JSON file data
    const fileInputObj = {
      FileByteArray: arrayBufferToBase64(fileBytes),
      Name: `${envelopeDocID}.json`,
      UniqueName: `${envelopeDocID}.json`,
      TimeStamp: new Date().toISOString(),
      HrefBlobUrl: `${tempuserGuid}/${fileName}`,
      Error: null,
      UnAuthConvertedDocumentName: null,
      JobId: null,
      downloadurl: null,
    };

    // Upload JSON file to Blob Storage
    await AzureBlobService.uploadFile(tempuserGuid, `${envelopeDocID}.json`, fileInputObj, "application/json");
  } catch (error) {
    console.error("Error adding signer files:", error);
  }
};

const processSignerFiles = async (envelopeDocID, docProfile) => {
  const isSignerFilesExist = await checkIfFileExists(envelopeDocID);
  if (!isSignerFilesExist) {
    await addSignerFilesIfMissing(envelopeDocID, docProfile.ModifiedName);
  }
};

export { processSignerFiles };
